/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        button: {
            borderRadius: {
                value: "2px",
                type: "dimension",
            },
            fontWeight: {
                value: 600,
                type: "fontWeight",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            height: {
                value: "40px",
                type: "dimension",
            },
            gap: {
                value: "12px",
                type: "dimension",
            },
            paddingHorizontal: {
                value: "16px",
                type: "dimension",
            },
            lineHeight: {
                value: "1.25rem",
                type: "dimension",
            },
            textTransform: {
                value: "none",
                type: "textTransform",
            },
            focus: {
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: false,
                                offsetX: 0,
                                offsetY: 0,
                                blur: 0,
                                spread: "1px",
                                color: "#ffffff",
                            },
                            {
                                inset: false,
                                offsetX: 0,
                                offsetY: 0,
                                blur: 0,
                                spread: "calc(2px + 1px)",
                                color: "#3e95fa",
                            },
                        ],
                        stringValue: "0 0 0 1px #ffffff, 0 0 0 calc(2px + 1px) #3e95fa",
                    },
                    type: "shadow",
                },
            },
            large: {
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                height: {
                    value: "56px",
                    type: "dimension",
                },
            },
            small: {
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                height: {
                    value: "32px",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.125rem",
                    type: "dimension",
                },
            },
            primary: {
                default: {
                    backgroundColor: {
                        value: "#455D82",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#364262",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#252C44",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
            secondary: {
                default: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    borderColor: {
                        value: "#455D82",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                    borderColor: {
                        value: "#364262",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    color: {
                        value: "#364262",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#94949452",
                        type: "color",
                    },
                    borderColor: {
                        value: "#252C44",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
            tertiary: {
                default: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                    color: {
                        value: "#364262",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#94949452",
                        type: "color",
                    },
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
            destructive: {
                primary: {
                    default: {
                        backgroundColor: {
                            value: "#AF292E",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#821F22",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#68181B",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
                secondary: {
                    default: {
                        backgroundColor: {
                            value: "#94949400",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderColor: {
                            value: "#AF292E",
                            type: "color",
                        },
                        color: {
                            value: "#AF292E",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#94949429",
                            type: "color",
                        },
                        borderColor: {
                            value: "#821F22",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        color: {
                            value: "#821F22",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#94949452",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderColor: {
                            value: "#68181B",
                            type: "color",
                        },
                        color: {
                            value: "#68181B",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#94949400",
                            type: "color",
                        },
                        borderColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
                tertiary: {
                    default: {
                        backgroundColor: {
                            value: "#94949400",
                            type: "color",
                        },
                        color: {
                            value: "#AF292E",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#94949429",
                            type: "color",
                        },
                        color: {
                            value: "#821F22",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#94949452",
                            type: "color",
                        },
                        color: {
                            value: "#68181B",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#94949400",
                            type: "color",
                        },
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
            },
            iconOnly: {
                paddingHorizontal: {
                    value: "8px",
                    type: "dimension",
                },
                width: {
                    value: "40px",
                    type: "dimension",
                },
                large: {
                    width: {
                        value: "56px",
                        type: "dimension",
                    },
                },
                small: {
                    width: {
                        value: "32px",
                        type: "dimension",
                    },
                },
            },
            icon: {
                height: {
                    value: "24px",
                    type: "dimension",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
